export default class SuccessScoringGroupService {
    static get HighId() {
        return 1;
    }
    static get MediumId() {
        return 2;
    }
    static get LowId() {
        return 3;
    }
}
